import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';

type InvoiceDrawerSummaryProps = {
  summary?: string;
  fromEmail?: string;
  onMarkAsPaid: () => void;
};

export const InvoiceDrawerSummary = ({ summary, fromEmail, onMarkAsPaid }: InvoiceDrawerSummaryProps) => {
  return (
    <Stack space={3} className="rounded-[10px] border-[0.5px] border-seapoint-gray-border bg-white p-4">
      {summary && (
        <Stack space={1}>
          <h3 className="text-sm font-medium leading-6 tracking-tight text-black">Invoice Summary</h3>

          <p className="text-pretty text-xs font-normal leading-6 tracking-tight text-seapoint-gray-text">{summary}</p>
        </Stack>
      )}

      {fromEmail && (
        <Inline justify="between" wrap="nowrap" className="w-full">
          <p className="text-sm font-medium leading-6 tracking-tight text-seapoint-gray-text">Received from</p>

          <p className="w-1/2 overflow-clip text-ellipsis text-right text-sm font-medium leading-6 tracking-tight text-black">
            {fromEmail}
          </p>
        </Inline>
      )}

      <Button variant="link" className="p-0 text-seapoint-blue-link" onClick={onMarkAsPaid}>
        Already paid this invoice?
      </Button>
    </Stack>
  );
};
